export const formatNigerianPhoneNumber = (value?: string) => {
  if (!value) return 'N/A';

  const digits = value.replace(/\D/g, '');
  if (!digits) return 'N/A';
  if (digits.startsWith('234')) return `+${digits}`;

  return `+234${digits.startsWith('0') ? digits.slice(1) : digits}`;
};

export const formatNumber = (value?: string | number) => {
  if (value === null || value === undefined || value === '') return 'N/A';

  const number = Number(value);
  return Number.isFinite(number) ? number.toLocaleString('en-US') : 'N/A';
};
